export default {
  '测试记录列表':'Test Record List',
  '日期':'Date',
  '请输入名称/发布人模糊搜索':'Search by name/publisher',
  '视频不存在':'The video does not exist.',
  '运动时长':'Exercise Duration',
  '锻炼时间':'Exercise Time',
  '测试记录':'Test Records',
  '姓名、学籍号模糊搜索':'Search by name/student ID',
  '用户列表':'User List',
  '未开始':'Not Started',
  '进行中':'In Progress',
  '已结束':'Ended',
  '关键字':'Keyword',
  '请输入名称关键字':'Enter name keyword',
  '秒':'Second(s)',

  //4.17
  '时间':'Time',
  '组别':'Group',
  '第':'Auxiliary',
  '组':'Group',
  '请输入组名ID成员模糊搜索':'Please enter the group name, ID and member for a fuzzy search',
  '随堂赛记录':'In-class game record',
  '组名':'Group Name',
  '组ID':'Group ID',
  '成员':'Member',
  '总成绩':'Total Score',
  '平均成绩':'Average Scores',
  '小时':'Hour',
  '分':'Minute',
  '完成时间':'Finish Time',
}